$('#fullpage').fullpage({
    sectionsColor: ['', '', '', '', ''],
    sectionSelector: '.vertical-scrolling',
    navigation: true,
    controlArrows: false
});